/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopGuildLeaderLeaderboard } from './TopGuildLeaderLeaderboard';
import {
    TopGuildLeaderLeaderboardFromJSON,
    TopGuildLeaderLeaderboardFromJSONTyped,
    TopGuildLeaderLeaderboardToJSON,
    TopGuildLeaderLeaderboardToJSONTyped,
} from './TopGuildLeaderLeaderboard';

/**
 * 
 * @export
 * @interface GetTopGuildLeadersLeaderboardResponse
 */
export interface GetTopGuildLeadersLeaderboardResponse {
    /**
     * 
     * @type {Array<TopGuildLeaderLeaderboard>}
     * @memberof GetTopGuildLeadersLeaderboardResponse
     */
    leaders: Array<TopGuildLeaderLeaderboard>;
}

/**
 * Check if a given object implements the GetTopGuildLeadersLeaderboardResponse interface.
 */
export function instanceOfGetTopGuildLeadersLeaderboardResponse(value: object): value is GetTopGuildLeadersLeaderboardResponse {
    if (!('leaders' in value) || value['leaders'] === undefined) return false;
    return true;
}

export function GetTopGuildLeadersLeaderboardResponseFromJSON(json: any): GetTopGuildLeadersLeaderboardResponse {
    return GetTopGuildLeadersLeaderboardResponseFromJSONTyped(json, false);
}

export function GetTopGuildLeadersLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTopGuildLeadersLeaderboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'leaders': ((json['leaders'] as Array<any>).map(TopGuildLeaderLeaderboardFromJSON)),
    };
}

export function GetTopGuildLeadersLeaderboardResponseToJSON(json: any): GetTopGuildLeadersLeaderboardResponse {
    return GetTopGuildLeadersLeaderboardResponseToJSONTyped(json, false);
}

export function GetTopGuildLeadersLeaderboardResponseToJSONTyped(value?: GetTopGuildLeadersLeaderboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaders': ((value['leaders'] as Array<any>).map(TopGuildLeaderLeaderboardToJSON)),
    };
}

